module.exports = __webpack_public_path__ + "static/media/Lars Christensen.35a5ff66.png";